module.exports = __webpack_public_path__ + "img/2_271.32ae25e5.png";